module.exports = __webpack_public_path__ + "static/media/img-70a2369b-fafb-11ee-8482-128e718ba88f.0dc29752.png";